import liabilityComponent from "./liability.component";

let liabilityModule = angular.module('liability', [])
    .component('liability', liabilityComponent)
    .name;

export default liabilityModule;


// WEBPACK FOOTER //
// ./client/app/components/reporting/components/liability/index.js